import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'reports.customerproduct',
  path: '/reports/customer-product',
    title: 'View Customer Count By Product',
    component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);